import { AgendaItem } from '@api';
import { IDragData, Space, IconButton, SessionSummaryDragDataKey } from '@components';
import { CirclePlusIcon, DragHandleIcon, PencilIcon, TrashIcon } from '@icons';
import * as React from 'react';
import './AgendaItemComp.scss';

interface AgendaItemCompProps {
    canEdit: boolean;
    item: AgendaItem;
    index: number;
    onAddDialogOpen: (index: number) => void;
    onEditDialogOpen: (itemToEdit: AgendaItem) => void;
    onDeleteDialogOpen: (itemToDelete: AgendaItem) => void;
}

function AgendaItemComp(props: AgendaItemCompProps): JSX.Element {
    const {
		canEdit,
        item,
        index,
        onAddDialogOpen,
        onEditDialogOpen,
        onDeleteDialogOpen,
	} = props;

    const [isDragging, setIsDragging] = React.useState<boolean>(false);

    const dragHandleRef = React.useRef(null);

    let dragTarget = null;
	const onMouseDownHandle = (ev: React.MouseEvent) => {
		if (!canEdit) {
			return;
		}
		dragTarget = ev.target;
	}

	const onDragEndHandle = () => {
		setIsDragging(false);
	}

	const onDragStartHandle = (ev: React.DragEvent, agendaItem: AgendaItem, itemIndex: number) => {
		if (!canEdit) {
			return;
		}

		if (dragHandleRef.current.contains(dragTarget)) {
			sessionStorage.setItem(SessionSummaryDragDataKey, JSON.stringify({
                source: 'agenda',
				agendaItemIndex: itemIndex,
                agendaItem: agendaItem
			} as IDragData));

			setIsDragging(true);
		} else {
			ev.preventDefault();
		}
	}

    const speakers = item.speakers && item.speakers.length ? <div className='agenda-item__speakers'><span className='block-name'>{`Докладчик${item.speakers.length > 1 ? "и" : ""}`}: </span>{item.speakers.join(", ")}</div> : null;
    const annotation = item.annotation ? <div className='agenda-item__annotation'>{item.annotation}</div> : null;

    const classes = 'agenda-item' + (isDragging ? ' dragging' : '');

    return (
        <div 
            draggable={true}
            onMouseDown={onMouseDownHandle}
            onDragStart={(ev) => onDragStartHandle(ev, item, index)}
            onDragEnd={onDragEndHandle}
            className={classes}
            key={item.id}>
                <div ref={dragHandleRef}>
                    <DragHandleIcon className='item-handle' />
                </div>
                <div>
                    <div className='agenda-item__text'><span className='item-num'>{index+1}.</span> {item.text}</div>
                    {annotation}
                    {speakers}
                </div>
                {canEdit && <Space gap="5px" className="agenda-item__actions">
                    <IconButton
                        onClick={() => onAddDialogOpen(index+1)}
                        icon={<CirclePlusIcon />}
                        iconSize="18px"
                        size="nogap"
                    />
                    <IconButton
                        onClick={() => onEditDialogOpen(item)}
                        icon={<PencilIcon />}
                        iconSize="18px"
                        size="nogap"
                    />
                    <IconButton
                        onClick={() => onDeleteDialogOpen(item)}
                        icon={<TrashIcon />}
                        iconSize="18px"
                        size="nogap"
                    />
                </Space>}
        </div>);
}

export {AgendaItemComp};